const isProgressive = (organizationName?: string) => (
  organizationName?.toLowerCase() === "progressive"
);

export default isProgressive;
